import React, { useEffect, useState } from 'react';
import api from '../../utils/api';
import CIUDADES from '../../data/ciudadesColombia';
import toast from 'react-hot-toast';
import { useWompiCheckout } from '../../utils/useWompiCheckout';
import { track } from '../../utils/analytics';

const fmtCOP = v => new Intl.NumberFormat('es-CO', { style: 'currency', currency: 'COP', minimumFractionDigits: 0 }).format(v || 0);

export default function OneClickCheckoutModal({ producto, cantidad, variaciones, precioUnitario, landingSlug, onClose, onSuccess }) {
  const [form, setForm] = useState({
    nombre_cliente: '', email_cliente: '', telefono_cliente: '',
    documento_cliente: '', direccion_entrega: '', ciudad_entrega: '', departamento_entrega: '',
  });
  const [ciudadQuery, setCiudadQuery] = useState('');
  const [ciudadOpen, setCiudadOpen] = useState(false);
  const [costoEnvio, setCostoEnvio] = useState(null);
  const [infoEnvio, setInfoEnvio] = useState(null);
  const { pagar, loading } = useWompiCheckout();

  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));
  const ciudadesFiltradas = ciudadQuery.length >= 2
    ? CIUDADES.filter(c => c.ciudad.toLowerCase().includes(ciudadQuery.toLowerCase())).slice(0, 8)
    : [];

  const subtotal = precioUnitario * cantidad;

  useEffect(() => {
    const ciudad = form.ciudad_entrega.trim();
    if (!ciudad) { setCostoEnvio(null); setInfoEnvio(null); return; }
    const t = setTimeout(async () => {
      try {
        const r = await api.post('/envios/calcular', { ciudad, valor_pedido: subtotal });
        const op = r.data.opciones[0];
        setCostoEnvio(op.precio);
        setInfoEnvio(op);
      } catch { setCostoEnvio(null); setInfoEnvio(null); }
    }, 600);
    return () => clearTimeout(t);
  }, [form.ciudad_entrega]);

  const envio = costoEnvio ?? 0;
  const total = subtotal + envio;

  const confirmar = async () => {
    if (!form.nombre_cliente || !form.email_cliente || !form.direccion_entrega || !form.ciudad_entrega)
      return toast.error('Completa todos los campos requeridos');
    if (costoEnvio === null) return toast.error('Ingresa una ciudad valida');
    try {
      const resultado = await pagar({
        ...form,
        items: [{ producto_id: producto.id, cantidad, variaciones }],
        costo_envio: envio,
        metodo_pago: 'wompi',
      });
      track('purchase', { valor: resultado.total, meta: { landing_slug: landingSlug, numero: resultado.numero } });
      onSuccess(resultado);
    } catch (err) {
      toast.error(err.message);
    }
  };

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.55)', zIndex: 2000, display: 'flex', alignItems: 'flex-end', justifyContent: 'center' }} onClick={onClose}>
      <div className="card" style={{ width: '100%', maxWidth: 480, maxHeight: '92vh', overflowY: 'auto', borderRadius: '20px 20px 0 0' }} onClick={e => e.stopPropagation()}>
        <div className="card-header">
          <span className="card-title">Comprar {producto.nombre}</span>
          <button onClick={onClose} style={{ background: 'none', border: 'none', fontSize: 20, cursor: 'pointer' }}>✕</button>
        </div>
        <div className="card-body">
          <div className="form-grid-2">
            {[
              { k: 'nombre_cliente', l: 'Nombre completo *', ph: 'María García', full: true },
              { k: 'email_cliente', l: 'Correo electrónico *', ph: 'tu@email.com', type: 'email' },
              { k: 'telefono_cliente', l: 'Teléfono / WhatsApp *', ph: '+57 300...' },
              { k: 'documento_cliente', l: 'CC / NIT *', ph: '123456789' },
              { k: 'direccion_entrega', l: 'Dirección completa *', ph: 'Calle 10 # 25-30, Barrio...', full: true },
            ].map(f => (
              <div key={f.k} className="form-group" style={f.full ? { gridColumn: '1/-1' } : {}}>
                <label className="form-label">{f.l}</label>
                <input className="form-input" type={f.type || 'text'} placeholder={f.ph}
                  value={form[f.k]} onChange={e => set(f.k, e.target.value)} />
              </div>
            ))}
            <div className="form-group" style={{ position: 'relative' }}>
              <label className="form-label">Ciudad *</label>
              <input className="form-input" placeholder="Escribe tu ciudad..."
                value={ciudadQuery || form.ciudad_entrega}
                onChange={e => {
                  setCiudadQuery(e.target.value);
                  setCiudadOpen(true);
                  if (!e.target.value) { set('ciudad_entrega', ''); set('departamento_entrega', ''); }
                }}
                onFocus={() => setCiudadOpen(true)}
                onBlur={() => setTimeout(() => setCiudadOpen(false), 200)}
                autoComplete="off"
              />
              {ciudadOpen && ciudadesFiltradas.length > 0 && (
                <div style={{ position: 'absolute', top: '100%', left: 0, right: 0, background: '#fff', border: '1.5px solid rgba(28,58,30,0.15)', borderRadius: 'var(--r-md)', zIndex: 100, boxShadow: '0 8px 24px rgba(0,0,0,0.1)', maxHeight: 200, overflowY: 'auto' }}>
                  {ciudadesFiltradas.map(c => (
                    <div key={c.ciudad + c.departamento}
                      onMouseDown={() => {
                        set('ciudad_entrega', c.ciudad);
                        set('departamento_entrega', c.departamento);
                        setCiudadQuery('');
                        setCiudadOpen(false);
                      }}
                      style={{ padding: '10px 16px', cursor: 'pointer', fontSize: 14, borderBottom: '1px solid rgba(28,58,30,0.06)' }}>
                      <span style={{ fontWeight: 600, color: 'var(--forest)' }}>{c.ciudad}</span>
                      <span style={{ color: 'var(--ink-faint)', fontSize: 12, marginLeft: 8 }}>{c.departamento}</span>
                    </div>
                  ))}
                </div>
              )}
            </div>
            <div className="form-group">
              <label className="form-label">Departamento</label>
              <input className="form-input" value={form.departamento_entrega} readOnly
                style={{ background: 'var(--cream-dark)', color: 'var(--ink-faint)' }}
                placeholder="Se completa automáticamente" />
            </div>
          </div>

          <div style={{ padding: '14px 0', borderTop: '1px solid rgba(28,58,30,0.1)', marginTop: 8 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 13, marginBottom: 6 }}>
              <span style={{ color: 'var(--ink-light)' }}>Subtotal ({cantidad}x)</span>
              <span style={{ fontWeight: 700 }}>{fmtCOP(subtotal)}</span>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 13, marginBottom: 6 }}>
              <span style={{ color: 'var(--ink-light)' }}>Envío</span>
              <span style={{ fontWeight: 700 }}>{costoEnvio === null ? 'Ingresa tu ciudad' : envio === 0 ? 'Gratis' : fmtCOP(envio)}</span>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', padding: '10px 0', fontWeight: 900, fontSize: 18, borderTop: '1px solid rgba(28,58,30,0.1)' }}>
              <span>Total</span>
              <span style={{ color: 'var(--forest)' }}>{fmtCOP(total)}</span>
            </div>
          </div>

          <button onClick={confirmar} disabled={loading} style={{
            width: '100%', padding: '15px', fontSize: 15, fontWeight: 800,
            background: loading ? '#ccc' : '#1C3A1E', color: '#9FBE6A', border: 'none',
            borderRadius: 'var(--r-lg)', cursor: loading ? 'not-allowed' : 'pointer',
          }}>
            {loading ? 'Procesando...' : 'Pagar de forma segura'}
          </button>
        </div>
      </div>
    </div>
  );
}
